'use client';

export default function HomePageSchema() {

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: 'https://4patriots.com', 
    name: '4Patriots',
    logo: 'https://cdn.builder.io/api/v1/image/assets%2F1adbd5971dac4273891f273603729777%2F1167243c96584e43be659c60d4857f4d?width=200',
    description: '4Patriots is an emergency preparedness brand founded by a husband and wife duo in Nashville, TN. They remain committed to improved self-reliance, freedom, and peace of mind for their customers with high-quality emergency food and equipment. With 4Patriots, you can find an impressive selection of delicious food that\'s all made in the U.S.A. They also offer practical solar and water filtration equipment so you can stay ready for anything.',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Help',
      telephone: '800-304-4202',
      email: 'help@4patriots.com',
      areaServed: 'US',
      availableLanguage: 'English'
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Nashville',
      addressRegion: 'Tennessee',
      addressCountry: 'United States',
      postalCode: '37204',
      streetAddress: '2920 Berry Hill Dr., Suite 300'
    },
    sameAs: [
      'https://facebook.com/4patriots',
      'https://instagram.com/thereal4patriots',
      'https://youtube.com/c/4Patriots'
    ]
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonLd),
      }}
    />
  );
}
